import { Injectable } from '@angular/core';
import { AbstractDataServiceDtoSummaryAdapter } from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import { CommunicationConfigurationEmailSenderDataService } from './communicationConfigurationEmailSender.dataservice';
import { CommunicationConfigurationEmailSenderSummaryModel } from '../../../api/entity/communicationConfigurationEmailSenderSummary.model';
import { CommunicationConfigurationEmailSenderSummaryConverter } from '../../../api/entity/converter/communicationConfigurationEmailSenderSummary.converter';
import { CommunicationConfigurationEmailSenderModel } from '../../../api/entity/communicationConfigurationEmailSender.model';

@Injectable({
    providedIn: 'root'
})
export class CommunicationConfigurationEmailSenderSummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<
    CommunicationConfigurationEmailSenderSummaryModel,
    CommunicationConfigurationEmailSenderSummaryConverter,
    CommunicationConfigurationEmailSenderModel
> {
    constructor(dataService: CommunicationConfigurationEmailSenderDataService, converter: CommunicationConfigurationEmailSenderSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): CommunicationConfigurationEmailSenderModel {
        return new CommunicationConfigurationEmailSenderModel();
    }
}